import { render, staticRenderFns } from "./ReferFriendModal.vue?vue&type=template&id=be959194&scoped=true"
import script from "./ReferFriendModal.vue?vue&type=script&lang=js"
export * from "./ReferFriendModal.vue?vue&type=script&lang=js"
import style0 from "./ReferFriendModal.vue?vue&type=style&index=0&id=be959194&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be959194",
  null
  
)

export default component.exports